module.exports = __webpack_public_path__ + "static/media/MT.dd04a697.svg";